import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { formatEtaFromDate } from "app/common/utils/date.util";
import { environment } from "environments/environment";
import { Observable, ReplaySubject, tap } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    private _notificationItems: ReplaySubject<InotificationItem[]> = new ReplaySubject<InotificationItem[]>(1);
    private _numberUnreadNotification: ReplaySubject<number> = new ReplaySubject<number>(1);


    constructor(private http: HttpClient) { }

    checkNotification(): Observable<InotificationItem[]> {
        let now: number = new Date().valueOf(); //maybe in old FE there is a mistake, should be divided by 1000?
        let latestNotificationDateRead: number = parseInt((localStorage.getItem('last_notification') ? localStorage.getItem('last_notification') : '0'), 10);
        return this.http.get<InotificationItem[]>(environment.apiBaseUrl + 'notifications/retriveNotificationGrowth.php?timestamp=' + now)
            .pipe(tap(items => {
                items = items.map(item => { return { ...item, etaAgo: formatEtaFromDate(item.timestamp) } });
                this._notificationItems.next(items);
                this._numberUnreadNotification.next(items.filter(item => latestNotificationDateRead < item.timestamp).length);
            }
            ));
    }

    get notificationItems$(): Observable<InotificationItem[]> {
        return this._notificationItems.asObservable();
    }

    get numberUnreadNotification$(): Observable<number> {
        return this._numberUnreadNotification.asObservable();
    }

    setNotificationRead(): void {
        localStorage.setItem('last_notification', new Date().valueOf() / 1000 + '');
        this._numberUnreadNotification.next(0);
    }
}


export interface InotificationItem {
    title: string
    description: string
    img_url: string
    timestamp: number
    redirect_url: string
    etaAgo?: { value: number, text: string }
}